


// import React, { useState, useEffect } from 'react';
// import '../styles/CompanyPolicy.css';

// const PolicyAdminDashboard = () => {
//   const [logs, setLogs] = useState({});
//   const [departments, setDepartments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [departmentFilter, setDepartmentFilter] = useState("All");

//   const policyKeys = [
//     "Probation Policy",
//     "WFH Policy",
//     "General Policy",
//     "Out of Office (OOO) Policy",
//     "Public Holidays for 2026",
//     "Performance Of Duties",
//     "Fair Compensation",
//     "Obligations of the Employee",
//     "Assignments",
//     "Confidentiality",
//     "Employee Termination"
//   ];

//   const API_URL = "/gt-api/acknowledgepolicy.php";

//   useEffect(() => {
//     const fetchAllData = async () => {
//       try {
//         const response = await fetch(API_URL);
//         const data = await response.json();

//         const logsData = data.logs || [];
//         const departmentsData = data.departments || [];

//         // ✅ GROUP LOGS
//         const groupedLogs = {};

//         logsData.forEach(log => {
//           const name = log.employee_name;

//           if (!groupedLogs[name]) {
//             groupedLogs[name] = {
//               department: log.Department,
//               policies: {}
//             };
//           }

//           // ✅ Only add if policy exists
//           if (log.policy_title) {
//             groupedLogs[name].policies[log.policy_title] = true;
//           }
//         });

//         setLogs(groupedLogs);

//         // ✅ SET ALL DEPARTMENTS (INCLUDING EMPTY ONES)
//         setDepartments(["All", ...departmentsData]);

//       } catch (error) {
//         console.error("Error fetching admin data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllData();
//   }, []);

// return (
//   <div className="management-card glass animate-fade">

//     {/* HEADER */}
//     <div className="card-header">
//       <h3>Policy Acknowledgement Tracker</h3>

//       <div className="header-actions">

//         <select
//           value={departmentFilter}
//           onChange={(e) => setDepartmentFilter(e.target.value)}
//           className="department-filter"
//         >
//           {departments.map((dept, index) => (
//             <option key={index} value={dept}>
//               {dept}
//             </option>
//           ))}
//         </select>

//         <span className="status-badge">
//           {loading ? "Fetching..." : "Database Live"}
//         </span>

//       </div>
//     </div>

//     {/* DESKTOP TABLE */}
//     <div className="table-container desktop-view">

//       <table className="management-table">

//         <thead>
//           <tr>
//             <th>Employee Name</th>

//             {policyKeys.map((key) => (
//               <th key={key} className="policy-header-cell">
//                 {key}
//               </th>
//             ))}
//           </tr>
//         </thead>

//         <tbody>

//           {!loading && Object.keys(logs).length > 0 ? (

//             Object.keys(logs)
//               .filter(
//                 (empName) =>
//                   departmentFilter === "All" ||
//                   logs[empName].department === departmentFilter
//               )
//               .map((empName) => (
//                 <tr key={empName}>

//                   <td className="emp-name-cell">
//                     <strong>{empName}</strong>

//                     <div className="emp-dept">
//                       {logs[empName].department}
//                     </div>
//                   </td>

//                   {policyKeys.map((key) => (
//                     <td key={key} className="text-center">
//                       {logs[empName].policies[key] ? (
//                         <span style={{ color: "#10b981" }}>✅</span>
//                       ) : (
//                         <span style={{ opacity: 0.3 }}>❌</span>
//                       )}
//                     </td>
//                   ))}

//                 </tr>
//               ))

//           ) : (

//             <tr>
//               <td
//                 colSpan={policyKeys.length + 1}
//                 className="text-center py-4"
//               >
//                 {loading
//                   ? "Loading employee data..."
//                   : "No database logs found."}
//               </td>
//             </tr>

//           )}

//         </tbody>

//       </table>

//     </div>

//     {/* MOBILE CARDS */}
//     <div className="mobile-policy-list">

//       {!loading && Object.keys(logs).length > 0 ? (

//         Object.keys(logs)
//           .filter(
//             (empName) =>
//               departmentFilter === "All" ||
//               logs[empName].department === departmentFilter
//           )
//           .map((empName) => (

//             <div
//               className="mobile-policy-card"
//               key={empName}
//             >

//               <div className="mobile-policy-name">
//                 {empName}
//               </div>

//               <div className="mobile-policy-dept">
//                 {logs[empName].department}
//               </div>

//               <div className="mobile-policy-grid">

//                 {policyKeys.map((key) => (

//                   <div
//                     className="mobile-policy-row"
//                     key={key}
//                   >
//                     <span className="policy-title-mobile">
//                       {key}
//                     </span>

//                     <span className="policy-status-mobile">
//                       {logs[empName].policies[key]
//                         ? "✅"
//                         : "❌"}
//                     </span>

//                   </div>

//                 ))}

//               </div>

//             </div>

//           ))

//       ) : (

//         <div className="mobile-policy-empty">

//           {loading
//             ? "Loading employee data..."
//             : "No database logs found."}

//         </div>

//       )}

//     </div>

//   </div>
// );
// };

// export default PolicyAdminDashboard;
























import React, { useState, useEffect } from 'react';
import '../styles/CompanyPolicy.css';

const PolicyAdminDashboard = () => {
  const [logs, setLogs] = useState({});
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [departmentFilter, setDepartmentFilter] = useState("All");

  const policyKeys = [
    "Probation Policy",
    "WFH Policy",
    "General Policy",
    "Out of Office (OOO) Policy",
    "Public Holidays for 2026",
    "Performance Of Duties",
    "Fair Compensation",
    "Obligations of the Employee",
    "Assignments",
    "Confidentiality",
    "Employee Termination"
  ];

  const API_URL = "/gt-api/acknowledgepolicy.php";

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const response = await fetch(API_URL);
        const data = await response.json();

        const logsData = data.logs || [];
        const departmentsData = data.departments || [];

        // ✅ GROUP LOGS
        const groupedLogs = {};

        logsData.forEach(log => {
          const name = log.employee_name;

          if (!groupedLogs[name]) {
            groupedLogs[name] = {
              department: log.Department,
              policies: {}
            };
          }

          // ✅ Only add if policy exists
          if (log.policy_title) {
            groupedLogs[name].policies[log.policy_title] = true;
          }
        });

        setLogs(groupedLogs);

        // ✅ SET ALL DEPARTMENTS (INCLUDING EMPTY ONES)
        setDepartments(["All", ...departmentsData]);

      } catch (error) {
        console.error("Error fetching admin data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

return (
  <div className="management-card glass animate-fade">

    {/* HEADER */}
    <div className="card-header">
      <h3>Policy Acknowledgement Tracker</h3>

      <div className="header-actions">

        <select
          value={departmentFilter}
          onChange={(e) => setDepartmentFilter(e.target.value)}
          className="department-filter"
        >
          {departments.map((dept, index) => (
            <option key={index} value={dept}>
              {dept}
            </option>
          ))}
        </select>

        <span className="status-badge">
          {loading ? "Fetching..." : "Database Live"}
        </span>

      </div>
    </div>

    {/* DESKTOP TABLE */}
    <div className="table-container desktop-view">

      <table className="management-table">

        <thead>
          <tr>
            <th className="emp-header-cell">Employee Name</th>

            {policyKeys.map((key) => (
              <th key={key} className="policy-header-cell" title={key}>
                {key}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>

          {!loading && Object.keys(logs).length > 0 ? (

            Object.keys(logs)
              .filter(
                (empName) =>
                  departmentFilter === "All" ||
                  logs[empName].department === departmentFilter
              )
              .map((empName) => (
                <tr key={empName}>

                  <td className="emp-name-cell">
                    <div className="emp-name-wrapper">
                      <span className="emp-name-title">{empName}</span>
                      {logs[empName].department && (
                        <span className="emp-dept-badge">{logs[empName].department}</span>
                      )}
                    </div>
                  </td>

                  {policyKeys.map((key) => (
                    <td key={key} className="policy-status-cell">
                      {logs[empName].policies[key] ? (
                        <span className="status-icon-read" title="Acknowledged">✓</span>
                      ) : (
                        <span className="status-icon-unread" title="Not Acknowledged">✕</span>
                      )}
                    </td>
                  ))}

                </tr>
              ))

          ) : (

            <tr>
              <td
                colSpan={policyKeys.length + 1}
                className="text-center py-4"
              >
                {loading
                  ? "Loading employee data..."
                  : "No database logs found."}
              </td>
            </tr>

          )}

        </tbody>

      </table>

    </div>

    {/* MOBILE CARDS */}
    <div className="mobile-policy-list">

      {!loading && Object.keys(logs).length > 0 ? (

        Object.keys(logs)
          .filter(
            (empName) =>
              departmentFilter === "All" ||
              logs[empName].department === departmentFilter
          )
          .map((empName) => (

            <div
              className="mobile-policy-card"
              key={empName}
            >

              <div className="mobile-policy-name">
                {empName}
              </div>

              <div className="mobile-policy-dept">
                {logs[empName].department}
              </div>

              <div className="mobile-policy-grid">

                {policyKeys.map((key) => (

                  <div
                    className="mobile-policy-row"
                    key={key}
                  >
                    <span className="policy-title-mobile">
                      {key}
                    </span>

                    <span className="policy-status-mobile">
                      {logs[empName].policies[key]
                        ? <span className="status-icon-read">✓</span>
                        : <span className="status-icon-unread">✕</span>}
                    </span>

                  </div>

                ))}

              </div>

            </div>

          ))

      ) : (

        <div className="mobile-policy-empty">

          {loading
            ? "Loading employee data..."
            : "No database logs found."}

        </div>

      )}

    </div>

  </div>
);
};

export default PolicyAdminDashboard;